/** GraphNode registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseGraphNode } from './parser';
const graphNodeRegistration = {
    typeName: 'GraphNode',
    parser: parseGraphNode,
};
nodeRegistry.register(graphNodeRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map